import {renderClientUploadImage} from '@/modules/clients/components/ClientUploadImage';
import ClientSelectAreaType from '@/modules/clients/components/ClientSelectAreaType';

export const fields = [
  {
    key: 'image',
    label: 'form.imageLabel',
    onlyEdit: true,
    render: renderClientUploadImage
  },
  {
    key: 'name',
    label: 'form.clientName',
    required: true, // this adds an entry to rules: [{ required: true, message: 'Username is required' }]
    placeholder: 'form.placeholderName',
    colSpan: 2,
  },
  {
    key: 'description',
    label: 'description',
    widget: 'textarea',
    placeholder: 'form.placeholderDescription',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'typeArea',
    placeholder: 'form.placeholderType',
    label: 'form.type',
    colSpan: 2,
    required: true,
    widget: ClientSelectAreaType
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    onlyView: true,
  }
];
